import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const generateAnalysis = createAsyncThunk('analysis/generate', async (request, { rejectWithValue }) => {
  try {
    const response = await api.post('/analysis/generate', request);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Failed to generate analysis');
  }
});

export const fetchReports = createAsyncThunk('analysis/fetchReports', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/analysis/reports');
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Failed to fetch reports');
  }
});

const analysisSlice = createSlice({
  name: 'analysis',
  initialState: {
    currentReport: null,
    reports: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearAnalysisError: (state) => {
      state.error = null;
    },
    setCurrentReport: (state, action) => {
      state.currentReport = action.payload;
    },
    clearCurrentReport: (state) => {
      state.currentReport = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateAnalysis.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateAnalysis.fulfilled, (state, action) => {
        state.loading = false;
        state.currentReport = action.payload;
        state.reports.unshift(action.payload);
      })
      .addCase(generateAnalysis.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.reports = action.payload;
      });
  },
});

export const { clearAnalysisError, setCurrentReport, clearCurrentReport } = analysisSlice.actions;
export default analysisSlice.reducer;
